<template lang="pug" src="./templates/DistributorsSlideshow.pug"></template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import { RepositoryFactory } from '../../repositoryFactory';
import notify from '../notify';

import 'swiper/css/swiper.css';

const DistributorRepostiory = RepositoryFactory.get('distributor');

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      distributors: [],
      swiperOptions: {
        slidesPerView: 1,
        watchSlidesVisibility: true,
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        },
        navigation: {
          nextEl: '.distributor-swiper-button--next',
          prevEl: '.distributor-swiper-button--prev',
        },
      },
    };
  },
  created() {
    this.get();
  },
  methods: {
    async get() {
      try {
        const { data } = await DistributorRepostiory.get();
        this.distributors = data;
      } catch (e) {
        notify.errors(this, e);
      }
    },
  },
};
</script>
